import { Action } from '@ngrx/store';

export const SAVE_EXTRACT_SUCCESS = '[Extract] Save Extract Success';

export class SaveExtractSuccessAction implements Action {
  readonly type = SAVE_EXTRACT_SUCCESS;
}



// WEBPACK FOOTER //
// ./src/app/extracts/store/actions/SaveExtractSuccessAction.ts